import { NgModule } from '@angular/core';
import { PrizmInputCorrectorDirective } from './input-corrector.directive';

@NgModule({
  declarations: [PrizmInputCorrectorDirective],
  exports: [PrizmInputCorrectorDirective],
})
export class PrizmInputCorrectorModule {}
